import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AlertTitle from '@mui/material/AlertTitle';
import { useAvailableCurrencies } from '@src/clients/financialSettings/hooks/useAvailableCurrencies';
import { Banner } from '@src/common/components/Banner';
import { BaseModal } from '@src/common/components/BaseModal';
import { Button } from '@src/common/components/button/Button';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { PreauthorizationForm } from '@src/orders/components/preauthorization/PreauthorizationForm';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  order: OrderListing;
}

export const PreauthorizationProvider = ({ order }: Props) => {
  const { t } = useTranslation();
  const [isFormOpen, setFormOpen] = useState(false);
  const closeForm = () => {
    setFormOpen(false);
  };

  const { currencies: availableCurrencies } = useAvailableCurrencies();

  const mandatoryCurrency =
    order.details.payment.currency &&
    availableCurrencies.includes(order.details.payment.currency)
      ? order.details.payment.currency
      : undefined;

  return (
    <>
      <Button
        style={{ width: 'fit-content', marginLeft: 'auto' }}
        onClick={() => setFormOpen(true)}
      >
        {t('preauthorization.preauthorizeAmount')}
      </Button>
      <BaseModal
        title={t('preauthorization.preauthorizeAmount')}
        open={isFormOpen}
        onClose={() => setFormOpen(false)}
      >
        <Stack direction="column" spacing={theme.spacing['6']}>
          {order.details.payment.currency && (
            <Banner severity="info" style={{ width: '100%' }}>
              <InfoOutlinedIcon />
              <Stack>
                <AlertTitle>
                  <Trans
                    i18nKey="preauthorization.currentlyPreauthorized"
                    values={{
                      amount: order.details.payment.settledAmount,
                      currency: order.details.payment.currency,
                    }}
                    components={{
                      strong: <strong style={{ fontWeight: 600 }} />,
                    }}
                  />
                </AlertTitle>
                <Typography style={{ fontWeight: 600 }}>
                  {t('preauthorization.currencyCannotBeChanged')}
                </Typography>
              </Stack>
            </Banner>
          )}
          <PreauthorizationForm
            clientId={order.billToClientId}
            orderId={order.id}
            onClose={closeForm}
            blockedCurrency={mandatoryCurrency}
          />
        </Stack>
      </BaseModal>
    </>
  );
};
